import React, { useState } from "react";
import { Loader2, ExternalLink, Maximize2, Minimize2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

const StructProView = () => {
  const [loading, setLoading] = useState(true);
  const [fullscreen, setFullscreen] = useState(false);

  return (
    <div className={`${fullscreen ? "fixed inset-0 z-50 bg-white" : "space-y-4"}`} data-testid="structpro-view">
      <div className={`flex items-center justify-between ${fullscreen ? "px-6 py-3 border-b-2 border-zinc-200" : ""}`}>
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-black tracking-tight uppercase font-['Chivo']">StructPro</h1>
          <Badge className="bg-[#FF4F00] text-white border-none text-[10px] uppercase tracking-widest">Odaaro.org</Badge>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => setFullscreen(!fullscreen)}
            className="border-2 border-zinc-200 hover:border-black text-xs h-8" data-testid="structpro-fullscreen-toggle">
            {fullscreen ? <Minimize2 size={14} className="mr-1.5" /> : <Maximize2 size={14} className="mr-1.5" />}
            {fullscreen ? "Exit Fullscreen" : "Fullscreen"}
          </Button>
          <a href="https://odaaro.org" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs font-bold text-[#0047AB] hover:underline" data-testid="structpro-external-link">
            Open in New Tab <ExternalLink size={12} />
          </a>
        </div>
      </div>
      <div className={`relative border-2 border-zinc-200 bg-white ${fullscreen ? "flex-1 h-[calc(100vh-60px)]" : ""}`}
        style={fullscreen ? {} : { height: "calc(100vh - 220px)", minHeight: "600px" }}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
            <div className="text-center">
              <Loader2 className="animate-spin mx-auto mb-3 text-[#0047AB]" size={32} />
              <p className="text-sm font-bold uppercase tracking-wide text-zinc-500">Loading StructPro</p>
              <p className="text-xs text-zinc-400 mt-1">Design Level of Effort | Cost Estimator Tool</p>
            </div>
          </div>
        )}
        <iframe src="https://odaaro.org" title="StructPro - Design Level of Effort | Cost Estimator Tool"
          className="w-full h-full border-0" onLoad={() => setLoading(false)} allow="clipboard-write"
          data-testid="structpro-iframe" />
      </div>
    </div>
  );
};

export default StructProView;
